import { render, staticRenderFns } from "./BrandCreateEdit.vue?vue&type=template&id=67b6d351&scoped=true&"
import script from "./BrandCreateEdit.vue?vue&type=script&lang=js&"
export * from "./BrandCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b6d351",
  null
  
)

export default component.exports